import * as React from 'react'
import { TaxFreeAmount } from '@/app/constants/taxFreeAmount'
import useContractFieldSetOptions from '../../options/useContractFieldSetOptions'
import { FieldsetSelectSmall } from '../../inputs/FieldsetSelectSmall'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

const TaxFree = ({ data, setData }) => {
  const { t } = useLocalize()
  const {contractTaxesFreeOptions} = useContractFieldSetOptions()

 React.useEffect(() => {
  if (!data) return

  if (data.includeTaxFreeAmount && data.taxFreeAmount === undefined) {
    setData(prev =>
      prev
        ? { ...prev, taxFreeAmount: TaxFreeAmount.Full }
        : prev
    )
  }

  if (!data.includeTaxFreeAmount && data.taxFreeAmount !== undefined) {
    setData(prev => {
      if (!prev) return prev
      const { taxFreeAmount, ...rest } = prev
      return rest
    })
  }
}, [data?.includeTaxFreeAmount])
  return (
    <div className='tw-w-full tw-flex tw-items-center tw-gap-2 tw-justify-between' >
      <p className='tw-text-xs tw-text-content-base '>{t('contract.amount')}</p>
      <FieldsetSelectSmall
        required
        placeholder="Wybierz..."
        value={data?.taxFreeAmount?.toString() ?? ''}
        name="type"
        onChange={(e) => {
          setData({
            ...data,
            taxFreeAmount: Number(e.target.value) as TaxFreeAmount,
          })
        }}
        options={contractTaxesFreeOptions}
      />
    </div>
  )
}

export default TaxFree
